import { API_BASE_URL } from 'src/env';
import { ApiReturnType } from 'src/interfaces/api/api';
import InterventionOrder, { PostInterventionOrderBody } from '../../interfaces/api/InterventionOrder';
import { Order } from '../../interfaces/Table';
import { toQueryParamsString } from '../../utils/ApiUtils';

export default {
  create: (interventionOrder: PostInterventionOrderBody & { token?: string }, fromProvider: boolean): ApiReturnType => {
    const params = new FormData();

    interventionOrder.attachments.forEach((attachment) => {
      params.append('attachments[]', attachment);
    });

    interventionOrder.attachments = [];

    Object.keys(interventionOrder).forEach((key) => {
      params.append(key, interventionOrder[key]);
    });

    return {
      endpoint: `${API_BASE_URL}/v2/intervention-order/intervention-orders${fromProvider ? '/external' : ''}`,
      body: params,
      method: 'POST',
    };
  },
  update: (id: string, interventionOrder: PostInterventionOrderBody): ApiReturnType => {
    const params = new FormData();

    interventionOrder.attachments.forEach((attachment) => {
      params.append('attachments[]', attachment);
    });

    interventionOrder.attachments = [];

    Object.keys(interventionOrder).forEach((key) => {
      if (interventionOrder[key]) {
        params.append(key, interventionOrder[key]);
      }
    });

    return {
      endpoint: `${API_BASE_URL}/v2/intervention-order/intervention-orders/${id}`,
      body: params,
      method: 'POST',
    };
  },
  invoice: (id: InterventionOrder['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/intervention-order/intervention-orders/${id}/invoice`,
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  }),
  getAttachment: (interventionOrderId: InterventionOrder['id'], attachmentId: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/intervention-order/intervention-orders/${interventionOrderId}/attachments/${attachmentId}`,
  }),
  get: (id: InterventionOrder['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/intervention-order/intervention-orders/${id}`,
    method: 'GET',
  }),
  getAll: (criteria: object, orderBy: string, order: Order = 'asc', page = 1, limit = 10): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/intervention-order/intervention-orders${toQueryParamsString({
      ...criteria,
      page,
      limit,
      orderBy,
      order,
    })}`,
    method: 'GET',
  }),
};
